import { FC } from 'react';
import { NoGpsrBanner } from 'components/NoGpsrBanner';
import { Page } from 'layouts/Page';

export const HomePage: FC = () => {
	return (
		<Page title="EAS GPSR Database">
			<NoGpsrBanner />
		</Page>
	);
};
